import React, { Component } from 'react';
import { Scanner } from '@yudiel/react-qr-scanner'; // Named export
import { Link, withRouter } from 'react-router-dom';
import { Button, Alert, Breadcrumb, BreadcrumbItem, Modal, ModalBody, ModalFooter, ModalHeader, } from 'reactstrap';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { Helmet } from "react-helmet";
import Typography from "@material-ui/core/Typography";

class QrScanPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: '',
      isProcessing: false,
      scanAction: 'checkIn',
      showModal: false, // Controls modal visibility
      modalMessage: "",
    };
    this.isMountedFlag = false;
    this.timeoutIdRef = null;
    this.visitId = null;
  }

  componentDidMount() {
    this.isMountedFlag = true;
    const searchParams = new URLSearchParams(this.props.location.search);
    const actionValue = searchParams.get("action");
    const vidValue = searchParams.get("vid");
    this.setState({
      scanAction: actionValue || 'checkIn',
      visitId: vidValue,
    });
  }

  componentDidUpdate(prevProps) {
    // Handle changes in props.location.search
    if (prevProps.location.search !== this.props.location.search) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const actionValue = searchParams.get("action");
      this.setState({ scanAction: actionValue || 'checkIn' });
    }

    // Handle updateVisitSuccess updates
    if (
      this.props.updateVisitSuccess &&
      prevProps.updateVisitSuccess !== this.props.updateVisitSuccess
    ) {

      // Check if the response status is 204
      if (this.props.updateVisitSuccess.message.includes('visit exceeded the allowed time')) {
          this.setState({
          showModal: true,
          modalMessage: this.props.updateVisitSuccess.message,
        });
      } else {
        this.props.history.push({
          pathname: "/ecm/call-logging/",
          search: `?q=single&vid=${this.state.visitId}`,
        });
      }
    }
    if (
      this.props.updateVisitError &&
      prevProps.updateVisitError !== this.props.updateVisitError
    ) {
      console.log("updateCarerVisitError", this.props.updateVisitError);
      this.setState({ message: this.props.updateVisitError.response.message });
    }
  }

  componentWillUnmount() {
    this.isMountedFlag = false;
    if (this.timeoutIdRef) {
      clearTimeout(this.timeoutIdRef);
    }
  }

  handleScan = async (data) => {
    if (data && !this.state.isProcessing) {
      this.setState({ isProcessing: true });
      try {
        const payload = {
          qr_code_identifier: data,
          carer_id: this.props.getCarerVisitSuccess[0].carer_email,
          action: this.state.scanAction,
          event_id: this.props.getCarerVisitSuccess[0].id,
        };
        // We update the visit here which in turn updates updateVisitSuccess
        this.props.updateVisit(payload);
      } catch (error) {
        if (this.isMountedFlag) {
          this.setState({
            message: `An error occurred during scanning: ${error.message}`,
          });
        }
        console.error('Scan Error:', error);
      } finally {
        if (this.isMountedFlag) {
          this.setState({ isProcessing: false });
        }
      }
    }
  };

  handleModalClose = () => {
    this.setState({ showModal: false });

    // Perform the redirect
    this.props.history.push({
      pathname: "/ecm/call-logging/",
      search: `?q=single&vid=${this.state.visitId}`,
    });
  };

  handleError = (error) => {
  console.error('QR Scanner Error:', error);

    if (this.isMountedFlag) {
      let errorMessage = 'QR Scanner encountered an error. Please try again.';

      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        errorMessage = "Camera access is blocked. To use the scanner, please enable camera permissions in your \
        browser settings. You can also refresh the page and select Allow when prompted.";
      }

      this.setState({ message: errorMessage });
    }
  };


  render() {
    const { message, isProcessing } = this.state;

    return (
      <React.Fragment>

        <Modal isOpen={this.state.showModal} toggle={this.handleModalClose}>
          <ModalHeader
            style={{ fontWeight: "bold"}}
            toggle={this.handleModalClose}>
            Scan Accepted
          </ModalHeader>
          <ModalBody>{this.state.modalMessage}</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.handleModalClose}>
              OK
            </Button>
          </ModalFooter>
        </Modal>

        <Helmet>
          <meta name="description" content="Electronic call monitoring" />
          <title>Excel Healthcare Services - Social and Domiciliary Care</title>
        </Helmet>
        <main>
          {/* Breadcrumb Navigation */}
          <div>
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>Scan</BreadcrumbItem>
            </Breadcrumb>
          </div>
        </main>
        <div className='container'>
          <div className="scanner-page">
            <Typography
              style={{fontSize: "120%", textAlign: "center", fontWeight: "bolder", padding: "16px 16px 32px 16px"}}
            >
              Scan QR Code
            </Typography>
            {message && (
              <Alert
                color={
                  message.toLowerCase().includes('successful') ? 'success' : 'danger'
                }
              >
                {message}
              </Alert>
            )}
            <div className="scanner-container">
              {isProcessing ? (
                <div className="custom-spinner"></div>
              ) : (
                <Scanner
                  onScan={this.handleScan}
                  onError={this.handleError}
                  delay={300}
                  facingMode="environment"
                  style={{ width: '50%' }}
                />
              )}
            </div>
            <div className="text-center mt-4 mb-4 p-4">
              <Button
                color="secondary"
                onClick={() => this.props.history.goBack()}
                className="d-flex align-items-center"
              >
                <CameraAltIcon  />
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(QrScanPage);
